/**
 * This function will yield to the main thread, allowing other tasks to run.
 * It will essentially break longer tasks up by creating new macrotasks
 * https://web.dev/articles/optimize-inp#yield_to_the_main_thread_often
 */
async function yieldToMain(): Promise<void> {
  // @ts-ignore
  if ('scheduler' in window && 'yield' in window.scheduler) {
    // @ts-ignore
    return await window.scheduler.yield();
  }
  return new Promise(resolve => {
    setTimeout(resolve, 0);
  });
}
export {yieldToMain};
